import { render, staticRenderFns } from "./UserDropdownMenuTest.vue?vue&type=template&id=0459ec36&scoped=true"
import script from "./UserDropdownMenuTest.vue?vue&type=script&lang=js"
export * from "./UserDropdownMenuTest.vue?vue&type=script&lang=js"
import style0 from "./UserDropdownMenuTest.vue?vue&type=style&index=0&id=0459ec36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0459ec36",
  null
  
)

export default component.exports